import { ImagePlusText } from '@design-system/image-plus-text';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { ImagePlusTextBlockProps } from './models';

const ImagePlusTextBlock = forwardRef<HTMLDivElement, ImagePlusTextBlockProps>(
  (
    { pageBlock: { heading, ...pageBlockProps }, componentId, ...rest },
    ref
  ) => (
    <PageBlock
      {...pageBlockProps}
      id={componentId}
      className="image-plus-text-block"
      ref={ref}
    >
      <ImagePlusText {...{ ...rest, heading }} />
    </PageBlock>
  )
);

export default ImagePlusTextBlock;
